import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
import router from '@/router'
import '@/assets/css/index.css'
import '@/assets/styles/base.css'
import '@/assets/styles/responsive.css'
import Notifications from '@kyvg/vue3-notification'
import VueTheMask from 'vue-the-mask'

import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import 'tw-elements';

import MediumEditor from 'vuejs-medium-editor';
import 'medium-editor/dist/css/medium-editor.css';
import 'vuejs-medium-editor/dist/themes/default.css';

import CKEditor from '@ckeditor/ckeditor5-vue';

library.add(fas, far, fab)
dom.watch();
store.dispatch('auth/loadStoredUser').finally(() => {
    const app = createApp(App);
    app
        .component('medium-editor', MediumEditor)
        .component('font-awesome-icon', FontAwesomeIcon)
        .use(store)
        .use(router)
        .use(Notifications)
        .use(VueTheMask)
        .use(CKEditor)
        .mount('#app');
});